'use client';
// ui1(instr/cl/ui1 3) — 카드 이미지 깨짐 폴백. <img> 가 실패하면(onerror · 수화 전에 이미 실패한 경우는 complete && naturalWidth 0)
//   가장 가까운 카드 루트([data-ds2-card])에 data-noimg 를 달아 «이미지 없는 컴팩트 카드» 와 같은 모양으로 접는다(ds2.css).
//   ⛔ 빈 박스·남색 자리표시를 남기지 않는다. 마크업·속성은 종전 <img> 그대로(SSR HTML 불변 — alt·loading·크기 동일).
// L5 perf — 반응형 srcset/sizes(lib/perf/img-srcset · 순수 · 서버·클라이언트 같은 값 → 수화 불일치 0).
//   후보가 없는 그림(생성 파생본·위성·카드·외부)은 속성 자체가 없다 = 종전 마크업. 스위치 perf.img_responsive OFF(PerfFlags) 도 종전 마크업.
import { useEffect, useRef } from 'react';
import { cardSrcSet, CARD_SIZES } from '@/lib/perf/img-srcset';
import { usePerfFlags } from '@/components/perf/PerfFlags';

export interface CardImgProps {
  src: string;
  alt: string;
  title?: string;
  width: number;
  height: number;
  loading: 'eager' | 'lazy';
  /** seo-audit S-8 — 첫 화면 LCP 이미지만 'high'(대표 현장 카드 첫 장). 없으면 속성 생략(종전 HTML 그대로). */
  fetchPriority?: 'high' | 'low';
  /** L5 — 생략 = src 로 자동 산출(cardSrcSet) · null = 만들지 않음 · 문자열 = 그대로. */
  srcSet?: string | null;
  /** L5 — srcset 이 있을 때만 붙는다. 기본 CARD_SIZES(목록 카드). */
  sizes?: string;
  /** L5 — 그림 원본 폭(사다리 상한). 기본 1600. */
  originalWidth?: number;
}

function fold(img: HTMLImageElement | null) {
  const root = img?.closest('[data-ds2-card]');
  if (root && !root.hasAttribute('data-noimg')) root.setAttribute('data-noimg', '');
}

export default function CardImg({ src, alt, title, width, height, loading, fetchPriority, srcSet, sizes, originalWidth }: CardImgProps) {
  const ref = useRef<HTMLImageElement>(null);
  const { imgResponsive } = usePerfFlags();
  useEffect(() => {
    const el = ref.current;
    if (el && el.complete && el.naturalWidth === 0) fold(el);
  }, [src]);
  const ss = imgResponsive ? (srcSet === undefined ? cardSrcSet(src, originalWidth) : srcSet) : null;
  const resp = ss ? { srcSet: ss, sizes: sizes ?? CARD_SIZES } : {};
  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img ref={ref} src={src} alt={alt} title={title} width={width} height={height} loading={loading} {...(fetchPriority ? { fetchPriority } : {})} {...resp} decoding="async" onError={(e) => fold(e.currentTarget)} />
  );
}
